interface NudgeBarProps {
  msgCount: number
}

export function NudgeBar({ msgCount }: NudgeBarProps) {
  if (msgCount < 50) return null

  if (msgCount >= 80) {
    return (
      <>
        <div className="hard-stop" role="alert">
          <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.2"/>
            <path d="M8 5v4.5M8 11.5v.3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
          </svg>
          <span>This session has reached its limit. Start a new chat to continue.</span>
        </div>
      </>
    )
  }

  return (
    <>
      <div className="nudge-bar" role="status" aria-live="polite">
        <svg className="nudge-icon" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="1.2"/>
          <path d="M8 11V8M8 5.5v.3" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
        </svg>
        <span>You've been in this session a while. Starting a new chat keeps responses sharp and accurate.</span>
      </div>
    </>
  )
}
